/**
 * Modelo pronto: Consulta de Produtos com IA + HTTP (catálogo).
 * Padrão: IA coleta → consulta API → IA apresenta → botões (comprar / outro / encerrar).
 *
 * Substitua a URL DEMO no nó HTTP pela API do seu catálogo
 * (ex.: .../api/whatsapp_buscar_produto.php?q=${termo_url}&key=SEU_TOKEN&limit=3).
 */

const PRODUTO_API_URL =
  "https://demo.exemplo.com/api/whatsapp_buscar_produto.php?q=${termo_url}&key=SEU_TOKEN_AQUI&limit=3";

const AI_COLLECT_PROMPT = `Você é o assistente de vendas desta loja.

MISSÃO ÚNICA: descobrir qual produto o cliente procura.

REGRAS OBRIGATÓRIAS:
- Na primeira resposta, cumprimente em UMA frase curta e pergunte qual produto ele busca (nome, marca ou tipo).
- Nunca responda apenas "como posso ajudar?" sem pedir o produto.
- Quando o cliente informar o produto, confirme com ele (ex.: "É o perfume X, correto?").
- Quando o cliente confirmar (sim/isso/correto), agradeça em UMA frase curta e PARE — o sistema consultará o estoque automaticamente. NÃO diga que vai verificar disponibilidade em mensagens longas; NÃO continue a conversa pedindo mais nada.
- Não invente preço, estoque nem disponibilidade; só colete o nome do produto.
- Seja breve (máximo 2 frases por mensagem).`;

const AI_RESULT_PROMPT = `Você é um assistente de vendas, amigável e objetivo.

O sistema consultou o catálogo e encontrou estas opções:

\${lista_texto}

Também há o destaque (1ª opção):
- Produto: \${nome}
- Preço: \${preco_formatado}
- Link: \${link}

REGRAS OBRIGATÓRIAS:
- Apresente APENAS as opções listadas acima (numeradas), com nome e preço.
- As fotos das opções já foram enviadas ao cliente (quando disponíveis).
- Pergunte qual opção ele prefere (pelo número) ou se deseja comprar a opção 1.
- NUNCA diga que um produto "não tem" / "não está disponível" / "não temos no catálogo".
- Se o cliente pedir OUTRO produto ou refinar (ex.: "quero apenas o perfume"), responda em UMA frase curta que você vai buscar agora — NÃO invente disponibilidade nem fique "verificando" em loop.
- Não invente produtos, preços ou estoque além dos listados.
- Seja breve.
- NÃO peça CEP.`;

function buildOpenAiIntegration(name, prompt, objective, autoCompleteOnObjective = false) {
  return {
    name,
    prompt,
    model: "gpt-4o-mini",
    voice: "texto",
    voiceKey: "",
    voiceRegion: "",
    ttsProvider: "azure",
    ttsModel: "tts-1",
    openaiTtsInstructions: "",
    ttsSpeed: 1,
    maxTokens: 600,
    temperature: 0.3,
    apiKey: "",
    maxMessages: 10,
    queueId: 0,
    delay: 5,
    flowMode: "temporary",
    maxInteractions: 8,
    completionTimeout: 15,
    continueKeywords: ["continuar", "próximo", "avançar"],
    objective,
    autoCompleteOnObjective,
    departmentTransfers: [],
    userTransfers: [],
    tagsAllowedForAI: [],
    lanesAllowedForAI: [],
    googleCalendarIntegrationId: 0,
    queueIdAfterCalendarCreate: 0,
    queueIdAfterCalendarUpdate: 0,
    queueIdAfterCalendarCancel: 0,
    sendAudioTranscriptionToContact: false,
    sendLinksAsTextWhenVoice: false,
    assetsAllowedForAI: [],
    maxAttachmentsPerReply: 2,
    provider: "openai",
  };
}

const N = {
  start: "tplProdStart01",
  msgIntro: "tplProdIntro02",
  aiColeta: "tplProdAiColeta03",
  msgWait: "tplProdWait04",
  httpProd: "tplProdHttp05",
  cond: "tplProdCond06",
  aiResult: "tplProdAiResult07",
  msgInvalid: "tplProdInvalid08",
  msgHttpErr: "tplProdHttpErr09",
  buttons: "tplProdBtn10",
  msgComprar: "tplProdBuy11",
  msgBye: "tplProdBye12",
  inputRetry: "tplProdInputRetry13",
};

const edge = (source, target, sourceHandle, targetHandle) => ({
  id: `xy-edge__${source}${sourceHandle || ""}-${target}${targetHandle || ""}`,
  type: "buttonedge",
  source,
  target,
  ...(sourceHandle ? { sourceHandle } : {}),
  ...(targetHandle ? { targetHandle } : {}),
});

const httpSaveVars = [
  { path: "ok", variable: "ok" },
  { path: "lista_texto", variable: "lista_texto" },
  { path: "total", variable: "total_produtos" },
  { path: "produto.nome", variable: "nome" },
  { path: "produto.descricao", variable: "descricao" },
  { path: "produto.preco", variable: "preco" },
  { path: "produto.preco_formatado", variable: "preco_formatado" },
  { path: "produto.imagem_url", variable: "imagem_url" },
  { path: "produto.link", variable: "link" },
  { path: "produto.id", variable: "produto_id" },
];

const httpResponseVars = httpSaveVars.map((item) => ({
  path: item.path,
  variableName: item.variable,
}));

const consultaProdutosComIaTemplate = {
  nodes: [
    {
      id: N.start,
      type: "start",
      position: { x: 0, y: 160 },
      data: { label: "Início" },
    },
    {
      id: N.msgIntro,
      type: "message",
      position: { x: 220, y: 160 },
      data: {
        label:
          "Olá! 👋 Bem-vindo.\n\nEm instantes um assistente vai te ajudar a encontrar o produto.",
      },
    },
    {
      id: N.aiColeta,
      type: "openai",
      position: { x: 480, y: 160 },
      data: {
        typebotIntegration: buildOpenAiIntegration(
          "Assistente Produtos",
          AI_COLLECT_PROMPT,
          "Coletar o nome do produto que o cliente procura e obter confirmação explícita de que está correto.",
          true
        ),
        timeoutEnabled: true,
        timeoutMinutes: 5,
        timeoutMessage:
          "Oi, ainda está aí? Me diga o nome do produto que você procura 🙂",
      },
    },
    {
      id: N.msgWait,
      type: "message",
      position: { x: 760, y: 160 },
      data: { label: "Consultando nosso catálogo... ⏳" },
    },
    {
      id: N.httpProd,
      type: "httpRequest",
      position: { x: 1020, y: 160 },
      data: {
        url: PRODUTO_API_URL,
        method: "GET",
        headersString: "",
        requestBody: "",
        headers: "",
        body: "",
        responseVar: "consultaProduto",
        timeout: 20000,
        sendProductImages: true,
        maxProductImages: 3,
        saveVariables: httpSaveVars,
        responseVariables: httpResponseVars,
      },
    },
    {
      id: N.cond,
      type: "condition",
      position: { x: 1280, y: 160 },
      data: {
        key: "ok",
        condition: 1,
        value: "true",
      },
    },
    {
      id: N.aiResult,
      type: "openai",
      position: { x: 1560, y: 40 },
      data: {
        typebotIntegration: buildOpenAiIntegration(
          "Resultado Produto",
          AI_RESULT_PROMPT,
          "Apresentar as opções do catálogo em lista numerada e perguntar qual o cliente deseja comprar. Se pedir outro item, avisar que vai buscar.",
          true
        ),
        timeoutEnabled: true,
        timeoutMinutes: 5,
        timeoutMessage: "Ainda posso te ajudar com esse produto?",
      },
    },
    {
      id: N.msgInvalid,
      type: "message",
      position: { x: 1560, y: 280 },
      data: {
        label:
          "Não encontrei esse produto no catálogo. 😕\n\nDigite outro nome para eu buscar de novo.",
      },
    },
    {
      id: N.inputRetry,
      type: "input",
      position: { x: 1840, y: 280 },
      data: {
        question: "Qual produto você quer buscar agora?",
        variableName: "termo",
        alwaysAsk: true,
        maxInvalidAttempts: 3,
        invalidMessage: "Digite o nome do produto, por favor.",
      },
    },
    {
      id: N.msgHttpErr,
      type: "message",
      position: { x: 1280, y: 360 },
      data: {
        label:
          "Tivemos um problema técnico ao consultar o catálogo. Por favor, tente novamente em alguns minutos.",
      },
    },
    {
      id: N.buttons,
      type: "button",
      position: { x: 1840, y: 40 },
      data: {
        message: "O que você deseja fazer?",
        arrayOption: [
          { number: 1, value: "Quero comprar" },
          { number: 2, value: "Buscar outro produto" },
          { number: 3, value: "Encerrar" },
        ],
      },
    },
    {
      id: N.msgComprar,
      type: "message",
      position: { x: 2120, y: 0 },
      data: {
        label:
          "Perfeito! 🛒\n\n*${nome}*\nValor: *${preco_formatado}*\n\nFinalize pelo link:\n${link}\n\nSe preferir, um atendente pode te ajudar a fechar a compra.",
      },
    },
    {
      id: N.msgBye,
      type: "message",
      position: { x: 2120, y: 200 },
      data: {
        label:
          "Obrigado pelo contato! 💕\nQuando quiser, é só chamar.",
      },
    },
  ],
  connections: [
    edge(N.start, N.msgIntro),
    edge(N.msgIntro, N.aiColeta),
    edge(N.aiColeta, N.msgWait, "a"),
    edge(N.msgWait, N.httpProd, "a", "httpRequest-in"),
    edge(N.httpProd, N.cond, "a"),
    edge(N.httpProd, N.msgHttpErr, "b"),
    edge(N.cond, N.aiResult, "a"),
    edge(N.cond, N.msgInvalid, "b"),
    edge(N.aiResult, N.buttons, "a"),
    edge(N.buttons, N.msgComprar, "a1"),
    edge(N.buttons, N.inputRetry, "a2"),
    edge(N.buttons, N.msgBye, "a3"),
    edge(N.msgInvalid, N.inputRetry, "a"),
    edge(N.inputRetry, N.msgWait, "a"),
  ],
};

export default consultaProdutosComIaTemplate;
